import { curry, getFirstItem, type PlatformEvent } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { hide } from 'lib/sequence/component/state/hidden'

/**
 * Displays `resultsList` and hides `recentsLabel` and `recentsList` if the `event`'s detail
 * contains a defined `term` property. If `term` is undefined, does the oposite.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const toggleActions = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
) => {
  const action = module[G.STATE][G.ACTION]
  const actionComponent = action[G.COMPONENT]
  const { quickActions = [] } = action[G.UI]
  const [btnPair] = actionComponent[G.ACTIONS]

  const filterAction = quickActions.find((quickAction: any) => quickAction.key === 'filter')

  const { activeTab } = component[G.STATE]

  filterAction.hidden = activeTab !== 1
  hide(btnPair, activeTab !== 0)
}

export default curry(toggleActions)
